import script from "./DashboardScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardScreen.vue?vue&type=script&setup=true&lang=js"

import "./DashboardScreen.vue?vue&type=style&index=0&id=1cce182e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cce182e"]])

export default __exports__